export default {
	"number": {
		"platformName": "tracking platform",
		"gpsSyncQuery": "gps synchronization query",
		"dataAbnormal": "data exception",
		"vehicleLocation": "vehicle positioning",
		"basicInformation": "basic information",
		"businessPartner": "business partner",
		"platformAccount": "account",
		"organizationNumber": "organization number",
		"platformKey": "key",
		"sourceType": "source type",
		"testTips": "test if this configuration is correct",
		"test": "test",
		"plateNumber": "license plate",
		"deviceNumber": "device no",
		"temperature": "temperature",
		"locationTime": "positioning time",
		"location": "position",
		"addTrackingAccount": "add tracking account",
		"self": "own",
		"ownVehicle": "own vehicle",
		"internalSharingVehicle": "internal shared vehicle",
		"externalSharingVehicle": "external shared vehicles",
		"accountOrKeyError": "account or key error",
		"checkTips": "please test through this account configuration first",
		"g7OrganizationNumber": "for g7 platform, please enter the institution number",
		"selectBusinessPartner": "please select a business partner"
	},
	"synchronousQuery": {
		"asyncTime": "synchronised time",
		"requestData": "access data",
		"resultData": "return data",
		"asyncInfo": "Synchronization information"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/number/number.js